export class NumericUtils {
    public static parse(value: string, defaultValue: number): number {
        return !isNaN(+value) ? +value : defaultValue;
    }

    public static parseMany(values: Array<string>, defaultValue: number): Array<number> {
        if (!values) {
            return [];
        }

        const result = values.map(x => NumericUtils.parse(x, defaultValue));
        return result;
    }
}
